export default __webpack_public_path__ + "static/media/S_CoreDream_4Regular.ad4f5df0.woff";